import { FETCH_WALLET_BALANCE, FETCH_WITHDRAWALS_MOBILE_ACCOUNTS, FETCH_WITHDRAWALS_BANK_ACCOUNTS, ADD_WITHDRAWALS_BANK_ACCOUNTS, ADD_WITHDRAWALS_MOBILE_ACCOUNTS, UPDATE_WITHDRAWALS_BANK_ACCOUNTS, UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS, DELETE_WITHDRAWALS_BANK_ACCOUNTS, DELETE_WITHDRAWALS_MOBILE_ACCOUNTS, FETCH_WITHDRAWALS_DATA, CANCEL_WITHDRAWAL_REQUEST } from "../../actions/actionTypes";

const initialState = {
  bankAccounts: [],
  mobileAccounts: [],
  walletBalance: "",
  tableData: { withdrawalRequestsSummary: [], withdrawalRequestsTableData: [] }
};

const withdrawalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_WITHDRAWALS_BANK_ACCOUNTS:
      const newBankAccount = action.payload;
      const existingBankAccount = state.bankAccounts.find(account => account.accountNumber === newBankAccount.accountNumber);

      if (existingBankAccount) {
        return state;
      } else {
        return {
          ...state,
          bankAccounts: state.bankAccounts.concat(newBankAccount)
        };
      }

    case ADD_WITHDRAWALS_MOBILE_ACCOUNTS:
      const newMobileAccount = action.payload;
      const existingMobileAccount = state.mobileAccounts.find(account => account.phoneNumber === newMobileAccount.phoneNumber);

      if (existingMobileAccount) {
        return state;
      } else {
        return {
          ...state,
          mobileAccounts: state.mobileAccounts.concat(newMobileAccount)
        };
      };

      case UPDATE_WITHDRAWALS_BANK_ACCOUNTS:
        const updatedBankAccount = action.payload[0] || action.payload;
        let accountNumberExists = false;

        for (const account of state.bankAccounts) {
          if (
            account.id !== updatedBankAccount.id &&
            account.accountNumber === updatedBankAccount.accountNumber
          ) {
            accountNumberExists = true;
            break;
          }
        }

        return {
          ...state,
          bankAccounts: state.bankAccounts.map(account =>
            account.id === updatedBankAccount.id
              ? (accountNumberExists ? account : updatedBankAccount)
              : account
          )
        };

      case UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS:
        const updatedMobileAccount = action.payload[0] || action.payload;
        let phoneNumberExists = false;

        for (const account of state.mobileAccounts) {
          if (
            account.id !== updatedMobileAccount.id &&
            account.phoneNumber === updatedMobileAccount.phoneNumber
          ) {
            phoneNumberExists = true;
            break;
          }
        }

        return {
          ...state,
          mobileAccounts: state.mobileAccounts.map(account =>
            account.id === updatedMobileAccount.id
              ? (phoneNumberExists ? account : updatedMobileAccount)
              :  account
          )
        };

    case DELETE_WITHDRAWALS_BANK_ACCOUNTS:
      return {
        ...state,
        bankAccounts: state.bankAccounts.filter(
          account => account.id !== action.payload
        )
      };

    case DELETE_WITHDRAWALS_MOBILE_ACCOUNTS:
      return {
        ...state,
        mobileAccounts: state.mobileAccounts.filter(
          account => account.id !== action.payload
        )
      };

    case FETCH_WITHDRAWALS_BANK_ACCOUNTS:
      return {
        ...state,
        bankAccounts: action.payload
      };

    case FETCH_WITHDRAWALS_MOBILE_ACCOUNTS:
      return {
        ...state,
        mobileAccounts: action.payload
      };

    case FETCH_WALLET_BALANCE:
      return {
        ...state,
        walletBalance: action.payload
      };

    case FETCH_WITHDRAWALS_DATA:
      return {
        ...state,
        tableData: action.payload
      }

      case CANCEL_WITHDRAWAL_REQUEST:
        const updatedWithdrawalRequests = state.tableData.withdrawalRequestsTableData.map(request => {
          if (request.id === action.payload.id) {
            return {
              ...request,
              status: action.payload.status
            };
          }
          return request;
        });

        return {
          ...state,
          tableData: {
            ...state.tableData,
            withdrawalRequestsTableData: updatedWithdrawalRequests
          }
        };

    default:
      return state;
  }
};

export default withdrawalReducer;
